import React, { useState, useRef, useEffect, useContext } from 'react';
import styles from './styles.module.css';
import { useTranslations } from 'next-intl';
import Button from '@/components/common/Button';
import SendCodeTimer from './SendCodeTimer';
import { LayoutContext } from '@/context/LayoutContext';
import { Pill } from '@/components/general/Pill';

const SignupCode = ({
  length = 4,
  onComplete,
  onKeyDown,
  onChange,
  // sendFunction,
  sendCodeFunction,
  info,
  setInfo,
  loading,
}) => {
  const tlogin = useTranslations('common');
  const { dir } = useContext(LayoutContext);

  const [code, setCode] = useState(
    info?.code?.length != 0
      ? String(info?.code)
          .split('')
          .map((digit) => digit)
      : new Array(length).fill(''),
  );
  // useEffect(() => {
  //   if (info?.code?.length == 0) {
  //     setCode(new Array(length).fill(''));
  //   }
  // }, [info?.code]);
  console.log('useris========', info);
  const inputsRef = useRef([]);

  useEffect(() => {
    onChange(code?.join(''), 'code');
  }, [code]);
  console.log('code==', code);
  // Handle input change
  const handleChange = (e, index) => {
    const value = e.target.value;
    const newCode = [...code];

    if (/^[0-9]$/.test(value)) {
      newCode[index] = value;
      setCode(newCode);

      // Move to the next input
      if (index < length - 1) {
        inputsRef.current[index + 1].focus();
      }

      // Call onComplete if code is fully entered
      if (newCode.every((digit) => digit !== '')) {
        onComplete(newCode.join(''));
      }
    }
  };

  // Handle key down events
  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      const newCode = [...code];

      // If current input is empty, move focus to previous input
      if (newCode[index] === '') {
        if (index > 0) {
          inputsRef.current[index - 1].focus();
        }
      } else {
        // Otherwise, clear the current input value
        newCode[index] = '';
        setCode(newCode);
      }
    }
    onKeyDown(e);
  };

  return (
    <div className={`flex flex-col  w-full h-auto mt-0`}>
      {/* <div className={`${styles.title} formTitle`}>{tlogin('code')}</div> */}
      <div className={`${styles.container} ltr`}>
        {code?.map((digit, index) => (
          <input
            inputMode="numeric"
            key={index}
            ref={(el) => (inputsRef.current[index] = el)}
            type="text"
            maxLength="1"
            value={digit}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            className={`${styles.input} ${digit?.length != 0 && styles.filledInput} ${info?.error?.code && 'inputError'}`}
          />
        ))}
      </div>
      {/* <Button onClick={sendFunction} className={styles.button} loading={loading}>
        {tlogin(`enter`)}
      </Button> */}
      <div className={`${styles.resend}`}>
        <SendCodeTimer
          // onSend={() => {
          //   onChange('', 'code');
          //   setCode(new Array(length).fill(''));
          //   sendCodeFunction();
          // }}
          onSend={async () => {
            const response = await sendCodeFunction();

            if (response?.code === 'INTERNAL_ERROR') {
              return response; // send it back to timer
            }

            onChange('', 'code');
            setCode(new Array(length).fill(''));

            return response;
          }}
          duration={60}
        />
      </div>
    </div>
  );
};
export default SignupCode;
